import { render } from "./ZhaiFootPC.vue?vue&type=template&id=24621c7c&scoped=true"
import script from "./ZhaiFootPC.vue?vue&type=script&lang=js"
export * from "./ZhaiFootPC.vue?vue&type=script&lang=js"

import "./ZhaiFootPC.vue?vue&type=style&index=0&id=24621c7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24621c7c"]])

export default __exports__